import { Box, Button } from '@eatclubcode/ec-component-library';
import React from 'react';
import ArrowLast from '../../assets/icons/arrows/last.svg';
import ArrowNext from '../../assets/icons/arrows/next.svg';
import { pluralise } from '../../utils/helpers';
import useStyles, { paginationButtonStyles } from './TableStyles';

const TablePagination = ({ table, options }) => {
  const classes = useStyles();

  return (
    <div className={classes.pagination}>
      <span style={{ display: 'flex', gap: '8px', alignItems: 'center', marginRight: '24px' }}>
        Rows per page: {/* <CleanDropdown */}
        {/*   items={options.pageSizeOptions.map((pageSizeOption) => ({ */}
        {/*     id: pageSizeOption, */}
        {/*     label: pageSizeOption, */}
        {/*     value: pageSizeOption, */}
        {/*   }))} */}
        {/*   value={{ */}
        {/*     id: table.getState().pagination.pageSize, */}
        {/*     label: table.getState().pagination.pageSize, */}
        {/*     value: table.getState().pagination.pageSize, */}
        {/*   }} */}
        {/*   onSelect={(newValue) => { */}
        {/*     console.log('selected', newValue); */}
        {/*     table.setPageSize(Number(newValue)); */}
        {/*   }} */}
        {/* /> */}
        <select
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
          className={classes.selectInput}
        >
          {options.pageSizeOptions.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {pageSize} {pluralise('row', pageSize)}
            </option>
          ))}
        </select>
      </span>
      <div>
        {Math.min(
          table.getRowCount(),
          table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1,
        )}
        -
        {Math.min(
          table.getRowCount(),
          table.getState().pagination.pageIndex * table.getState().pagination.pageSize +
            table.getState().pagination.pageSize,
        )}{' '}
        of {table.getRowCount().toLocaleString()}
      </div>

      <Box className={classes.footerButtons}>
        <Button
          type='icon'
          onClick={() => table.firstPage()}
          disabled={!table.getCanPreviousPage()}
          style={paginationButtonStyles}
        >
          <ArrowLast style={{ transform: 'scaleX(-1)' }} />
        </Button>
        <Button
          type='icon'
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
          style={paginationButtonStyles}
        >
          <ArrowNext style={{ transform: 'scaleX(-1)' }} />
        </Button>
        <Button
          type='icon'
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
          style={paginationButtonStyles}
        >
          <ArrowNext />
        </Button>
        <Button
          type='icon'
          onClick={() => table.lastPage()}
          disabled={!table.getCanNextPage()}
          style={paginationButtonStyles}
        >
          <ArrowLast />
        </Button>
      </Box>
    </div>
  );
};

export default TablePagination;
